import { LEPC_IDS } from "../../../constants";
import { StaffActivitiesByDescription, StaffActivityDetails } from "../../types";

const PA_STATE_PORTAL_BASE: StaffActivityDetails = {
  parameters: {
    linkUrls: ["https://www.lipatts.pa.gov/Account/Login.aspx"],
    staffInputs: {
      documentTypes: {
        certification: true,
        report: true,
      },
    },
  },
  jurisdictionType: "State",
  activityType: "Portal",
  state: "PA",
};

export const staffActivities: StaffActivitiesByDescription = {
  "Berks County Portal": {
    parameters: {
      linkUrls: ["https://btf.countyofberks.com/TIERIIMANAGER/Account/Login.aspx"],
      staffInputs: {
        fees: true,
        documentTypes: {
          report: true,
          invoice: true,
        },
      },
      includeLepcs: [
        {
          id: "238",
          name: "Berks County",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "PA",
  },
  "Pennsylvania State Portal": {
    ...PA_STATE_PORTAL_BASE,
    parameters: {
      ...PA_STATE_PORTAL_BASE.parameters,
      staffInputs: {
        ...PA_STATE_PORTAL_BASE.parameters.staffInputs,
        fees: true,
      },
    },
  },
  "Pennsylvania State Portal - Revision": {
    ...PA_STATE_PORTAL_BASE,
    parameters: {
      ...PA_STATE_PORTAL_BASE.parameters,
      staffInputs: {
        ...PA_STATE_PORTAL_BASE.parameters.staffInputs,
        fees: false,
      },
    },
  },
  "Montgomery, PA County Portal": {
    parameters: {
      linkUrls: [
        "https://www.notion.so/encamp/7140712780864ff2b37facb42458b148?v=9f6157b1b53d44dfb6248c55f26b2aaa",
      ],
      staffInputs: {
        fees: false,
        documentTypes: {
          submission: true,
        },
      },
      includeLepcs: [
        {
          id: LEPC_IDS.PA.MONTGOMERY_COUNTY,
          name: "Montgomery County",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "PA",
  },
  "Complete Washington County Invoice": {
    parameters: {
      staffInputs: {
        fees: true,
        documentTypes: {
          invoice: true,
        },
      },
      includeLepcs: [
        {
          id: LEPC_IDS.PA.WASHINGTON_COUNTY,
          name: "Washington County",
        },
      ],
    },
    jurisdictionType: "City/County",
    state: "PA",
    dependsOn: ["Prior Activity"],
  },
  "Potter County LEPC": {
    parameters: {
      linkUrls: [
        "https://www.notion.so/encamp/7140712780864ff2b37facb42458b148?v=9f6157b1b53d44dfb6248c55f26b2aaa",
      ],
      staffInputs: {
        fees: false,
        documentTypes: {
          submission: true,
        },
      },
      includeLepcs: [
        {
          id: LEPC_IDS.PA.POTTER_COUNTY,
          name: "Potter County",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "PA",
  },
  "Complete Potter County Invoice": {
    parameters: {
      staffInputs: {
        fees: true,
        documentTypes: {
          invoice: true,
        },
      },
      includeLepcs: [
        {
          id: LEPC_IDS.PA.POTTER_COUNTY,
          name: "Potter County",
        },
      ],
    },
    jurisdictionType: "City/County",
    state: "PA",
    dependsOn: ["Potter County LEPC"],
  },
  "Complete Centre County Invoice": {
    parameters: {
      staffInputs: {
        fees: true,
        documentTypes: {
          invoice: true,
        },
      },
      includeLepcs: [
        {
          id: LEPC_IDS.PA.CENTRE_COUNTY,
          name: "Centre County",
        },
      ],
    },
    jurisdictionType: "City/County",
    state: "PA",
    dependsOn: ["Prior Activity"],
  },
  "Complete Crawford County Invoice": {
    parameters: {
      staffInputs: {
        fees: true,
        documentTypes: {
          invoice: true,
        },
      },
      includeLepcs: [
        {
          id: LEPC_IDS.PA.CRAWFORD_COUNTY,
          name: "Crawford County",
        },
      ],
    },
    jurisdictionType: "City/County",
    state: "PA",
    dependsOn: ["Prior Activity"],
  },
};
